import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { useSeo } from "../lib/settings";
import { useList, PLAYED, FAV, clearPlayed } from "../lib/store";
import { StaticGrid } from "../components/GameGrid";

export function MyGames({ kind }) {
  const slugs = useList(kind === "played" ? PLAYED : FAV);
  const [items, setItems] = useState(null);
  const title = kind === "played" ? "Giochi Giocati" : "I tuoi Preferiti";
  useSeo({ title, noindex: true });
  useEffect(() => {
    if (!slugs.length) {
      setItems([]);
      return;
    }
    api.post("/games/by-slugs", { slugs }).then((r) => setItems(Array.isArray(r.data) ? r.data : [])).catch(() => setItems([]));
  }, [slugs]);
  return (
    <div className="content" data-testid={`my-games-${kind}`}>
      <div className="page-title">
        <h1>{title}</h1>
        <p>{kind === "played" ? "Gli ultimi giochi a cui hai giocato su questo dispositivo." : "I giochi che hai salvato con il cuore."}</p>
      </div>
      {items && items.length === 0 && (
        <div className="gg-empty" data-testid="my-games-empty">
          {kind === "played" ? "Non hai ancora giocato a nessun gioco." : "Non hai ancora aggiunto giochi ai preferiti."}{" "}
          <Link to="/migliori-giochi">Scopri i giochi migliori</Link>
        </div>
      )}
      {items && items.length > 0 && <StaticGrid items={items} />}
      {kind === "played" && items?.length > 0 && (
        <button className="gg-loadmore" onClick={clearPlayed} data-testid="clear-played-btn">Cancella cronologia</button>
      )}
    </div>
  );
}
